<template>
  <el-dialog title="Adicionar" center :visible.sync="dialog">
    <el-form ref="form" :model="remetenteForm" :rules="rules" label-position="top" label-width="120px">
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item class="no-margin-bottom" label="Contato" :required="true">
            <el-input v-model="remetenteForm.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="18" :sm="18" :md="18" :lg="12" :xl="12">
          <el-form-item class="no-margin-bottom" :label="$t('cep')" prop="cep" :required="true">
            <el-input maxlength="9" v-model="remetenteForm.cep" v-mask="'#####-###'" v-loading="loading"
              @blur="zipcode()"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item :label="$t('endereco')" prop="address" class="no-margin-bottom" :required="true">
            <el-input v-model="remetenteForm.address"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="10">
          <el-form-item :label="$t('bairro')" prop="neighborhood" class="no-margin-bottom" :required="true">
            <el-input v-model="remetenteForm.neighborhood"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
          <el-form-item class="no-margin-bottom" :label="$t('cidade')" prop="city" :required="true">
            <el-input v-model="remetenteForm.city"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6">
          <el-form-item class="no-margin-bottom" :label="$t('estado')" prop="state" :required="true">
            <el-input v-model="remetenteForm.state"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="6">
          <el-form-item class="no-margin-bottom" label="Número" :required="true">
            <el-input v-model="remetenteForm.number"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="18">
          <el-form-item class="no-margin-bottom" label="Complemento">
            <el-input v-model="remetenteForm.extent"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialog = false">Cancelar</el-button>
      <el-button type="success" @click="save()">Salvar</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { PostOfficeService } from "@/services/post.office/post.office.services";

export default {
  name: "ZipcodeAdd",
  props: {
    state: String,
  },
  data() {
    return {
      loading: false,
      dialog: false,
      remetenteForm: {
        cep: "",
        name: "",
        address: "",
        neighborhood: "",
        city: "",
        state: "",
        number: "",
        extent: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Nome é obrigatório",
            trigger: "blur",
          },
        ],
        cep: [
          {
            required: true,
            message: "CEP é obrigatório",
            trigger: "blur",
          },
        ],
        number: [
          {
            required: true,
            message: "Número é obrigatório",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    zipcode: function () {
      const vm = this;
      if (!vm.remetenteForm.cep) {
        return false;
      }
      vm.loading = true;
      PostOfficeService.zipcode(vm.remetenteForm.cep)
        .then((response) => {
          vm.remetenteForm.address = response.end;
          vm.remetenteForm.city = response.cidade;
          vm.remetenteForm.state = response.uf;
          vm.remetenteForm.neighborhood = response.bairro;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: i18n.tc("cep-invalido"),
            duration: 5000,
          });
        })
        .finally(() => (vm.loading = false));
    },
    open() {
      const vm = this;
      vm.dialog = true;
      for (var key in vm.remetenteForm) {
        vm.remetenteForm[key] = '';
      }
    },
    save() {
      const vm = this;
      vm.$refs["form"].validate((valid) => {
        if (valid) {
          vm.dialog = false;
          vm.$emit("save", vm.remetenteForm);
        }
      });
    },
  },
};
</script>
